import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { TurnReportResource, turnReportsPut } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useEditTurnReport = (
  options: UseMutationOptions<
    void,
    unknown,
    Omit<TurnReportResource, 'turn'> & { turn: number }
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (report) =>
      extractData(
        turnReportsPut({
          path: { reportId: report.id! },
          body: report as unknown as TurnReportResource,
        })
      ),
    mutationKey: ['turnReports', 'update'],
    ...options,
    onSuccess(data, variables, mutationResult, context) {
      queryClient.invalidateQueries({
        queryKey: ['turnReports', variables.id],
      });
      options.onSuccess?.(data, variables, mutationResult, context);
    },
  });
};
